import { BsGithub, BsTwitter } from "react-icons/bs";
import { SiGmail } from "react-icons/si";
import "./contact.css";

const Contact = () => {
  return (
    <>
      <div className="contactContainer" style={{ animationDelay: "400ms" }}>
        <h1 className="contactHead fadeDown">Thanks for taking the time to reach out!</h1>
        <h2 className="contactHead fadeUp">Here's how you can get in touch with me :)</h2>

        <div className="contactsList fadeUp">
          {/* <a
            href="https://www.linkedin.com/in/sonu-bardai/"
            target="_blank"
            className="projectWindowAnchor"
            rel="noreferrer"
          >
            <div className="contactWindowContainer">
              <BsLinkedin className="contactIcon" />
              <h1 className="contactName">LinkedIn</h1>
              <div className="contactId">sonu-bardai</div>
            </div>
          </a> */}

          <a href="https://twitter.com/SonuBardai" target="_blank" className="projectWindowAnchor" rel="noreferrer">
            <div className="contactWindowContainer">
              <BsTwitter className="contactIcon" />
              <h1 className="contactName">Twitter</h1>
              <div className="contactId">SonuBardai</div>
            </div>
          </a>
          <a href="https://github.com/SonuBardai" target="_blank" className="projectWindowAnchor" style={{ animationDelay: "800ms" }} rel="noreferrer">
            <div className="contactWindowContainer">
              <BsGithub className="contactIcon" />
              <h1 className="contactName">GitHub</h1>
              <div className="contactId">SonuBardai</div>
            </div>
          </a>
          <a href="mailto:sonubardai9@gmail.com" target="_blank" className="projectWindowAnchor" style={{ animationDelay: "1200ms" }} rel="noreferrer">
            <div className="contactWindowContainer">
              <SiGmail className="contactIcon" />
              <h1 className="contactName">Mail</h1>
              <div className="contactId">sonubardai9@gmail.com</div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default Contact;
